import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";

const state = {
  projectsSubscriptions: null,
  projectsSubscriptionsPagination: null,
  currentProjectSubscription: null,
  clientsSubscriptions: null,
  clientsSubscriptionsPagination: null,
  currentClientSubscription: null,
  usersSubscriptions: null,
  usersSubscriptionsPagination: null,
  currentUserSubscription: null,
};

const getters = {
  subscriptions_get_projects_subscriptions: (state) => {
    return state.projectsSubscriptions;
  },
  subscriptions_get_projects_subscriptions_pagination: (state) => {
    return state.projectsSubscriptionsPagination;
  },
  subscriptions_get_current_project_subscription: (state) => {
    return state.currentProjectSubscription;
  },
  subscriptions_get_clients_subscriptions: (state) => {
    return state.clientsSubscriptions;
  },
  subscriptions_get_clients_subscriptions_pagination: (state) => {
    return state.clientsSubscriptionsPagination;
  },
  subscriptions_get_current_client_subscription: (state) => {
    return state.currentClientSubscription;
  },
  subscriptions_get_users_subscriptions: (state) => {
    return state.usersSubscriptions;
  },
  subscriptions_get_users_subscriptions_pagination: (state) => {
    return state.usersSubscriptionsPagination;
  },
  subscriptions_get_current_user_subscription: (state) => {
    return state.currentUserSubscription;
  },
};

const mutations = {
  SUBSCRIPTIONS_SET_PROJECTS_SUBSCRIPTIONS(state, subscriptions) {
    state.projectsSubscriptions = subscriptions;
  },
  SUBSCRIPTIONS_SET_PROJECTS_SUBSCRIPTIONS_PAGINATION(state, pagination) {
    state.projectsSubscriptionsPagination = pagination;
  },
  SUBSCRIPTIONS_SET_PROJECT_SUBSCRIPTION(state, subscription) {
    state.currentProjectSubscription = subscription;
  },
  SUBSCRIPTIONS_SET_CLIENTS_SUBSCRIPTIONS(state, subscriptions) {
    state.clientsSubscriptions = subscriptions;
  },
  SUBSCRIPTIONS_SET_CLIENTS_SUBSCRIPTIONS_PAGINATION(state, pagination) {
    state.clientsSubscriptionsPagination = pagination;
  },
  SUBSCRIPTIONS_SET_CLIENT_SUBSCRIPTION(state, subscription) {
    state.currentClientSubscription = subscription;
  },
  SUBSCRIPTIONS_SET_USERS_SUBSCRIPTIONS(state, subscriptions) {
    state.usersSubscriptions = subscriptions;
  },
  SUBSCRIPTIONS_SET_USERS_SUBSCRIPTIONS_PAGINATION(state, pagination) {
    state.usersSubscriptionsPagination = pagination;
  },
  SUBSCRIPTIONS_SET_USER_SUBSCRIPTION(state, subscription) {
    state.currentUserSubscription = subscription;
  },
};

const actions = {
  getProjectsSubscriptions({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "title",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamSubscriptionsProjectsGet(params)
            .then((res) => {
              console.log("teamSubscriptionsProjectsGet", res);
              commit("SUBSCRIPTIONS_SET_PROJECTS_SUBSCRIPTIONS", res.data.data);
              commit("SUBSCRIPTIONS_SET_PROJECTS_SUBSCRIPTIONS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getProjectSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSubscriptionGet(params)
            .then((res) => {
              console.log("teamProjectsProjectSubscriptionGet", res);
              commit("SUBSCRIPTIONS_SET_PROJECT_SUBSCRIPTION", res.data.data.subscribed);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  postProjectSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.params.project ? payload.params.project : payload.project,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSubscriptionPost(params)
            .then((res) => {
              console.log("teamProjectsProjectSubscriptionPost", res);
              commit("SUBSCRIPTIONS_SET_PROJECT_SUBSCRIPTION", true);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteProjectSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        project: payload.params.project ? payload.params.project : payload.project,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectSubscriptionDelete(params)
            .then((res) => {
              console.log("teamProjectsProjectSubscriptionDelete", res);
              commit("SUBSCRIPTIONS_SET_PROJECT_SUBSCRIPTION", false);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClientsSubscriptions({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamSubscriptionsClientsGet(params)
            .then((res) => {
              console.log("teamSubscriptionsClientsGet", res);
              commit("SUBSCRIPTIONS_SET_CLIENTS_SUBSCRIPTIONS", res.data.data);
              commit("SUBSCRIPTIONS_SET_CLIENTS_SUBSCRIPTIONS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getClientSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientSubscriptionGet(params)
            .then((res) => {
              console.log("teamClientsClientSubscriptionGet", res);
              commit("SUBSCRIPTIONS_SET_CLIENT_SUBSCRIPTION", res.data.data.subscribed);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  postClientSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        client: payload.params.client ? payload.params.client : payload.client,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientSubscriptionPost(params)
            .then((res) => {
              console.log("teamClientsClientSubscriptionPost", res);
              commit("SUBSCRIPTIONS_SET_CLIENT_SUBSCRIPTION", true);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteClientSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        client: payload.params.client ? payload.params.client : payload.client,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamClientsClientSubscriptionDelete(params)
            .then((res) => {
              console.log("teamClientsClientSubscriptionDelete", res);
              commit("SUBSCRIPTIONS_SET_CLIENT_SUBSCRIPTION", false);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getUsersSubscriptions({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamSubscriptionsUsersGet(params)
            .then((res) => {
              console.log("teamSubscriptionsUsersGet", res);
              commit("SUBSCRIPTIONS_SET_USERS_SUBSCRIPTIONS", res.data.data);
              commit("SUBSCRIPTIONS_SET_USERS_SUBSCRIPTIONS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getUserSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamUsersUserSubscriptionGet(params)
            .then((res) => {
              console.log("teamUsersUserSubscriptionGet", res);
              commit("SUBSCRIPTIONS_SET_USER_SUBSCRIPTION", res.data.data.subscribed);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  postUserSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        user: payload.params.user ? payload.params.user : payload.user,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamUsersUserSubscriptionPost(params)
            .then((res) => {
              console.log("teamUsersUserSubscriptionPost", res);
              commit("SUBSCRIPTIONS_SET_USER_SUBSCRIPTION", true);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteUserSubscription({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        user: payload.params.user ? payload.params.user : payload.user,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamUsersUserSubscriptionDelete(params)
            .then((res) => {
              console.log("teamUsersUserSubscriptionDelete", res);
              commit("SUBSCRIPTIONS_SET_USER_SUBSCRIPTION", false);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
